export default __webpack_public_path__ + "static/media/vip-bonus-bg.97864d98.webp";